window.onload = function () {
	console.log('Init JS');
	Solver.setHeaderHeight();

	let wishlist = Solver.wishlist.get();
	const cards = document.querySelectorAll('[data-product-card]');

	if (!wishlist) Solver.wishlist.set();
	Solver.wishlist.ui(wishlist);

	const sections = document.querySelectorAll('main section');
	sections.forEach((section, i) => (section.style.zIndex = i));

	const footer = document.querySelector('footer');
	if (footer && sections) footer.style.zIndex = sections.length;

	Solver.waves();

	window.addEventListener('resize', function () {
		Solver.setHeaderHeight();
		Solver.waves();
	});
};
